import removeCommas from "./removeCommas";
import numberFormat from "./numberFormat";

export default function addPrecision(string) {
  if (String(string).indexOf(".") === -1) {
    return (string || 0) + ".00";
  }
  return numberFormat(parseFloat(removeCommas(string)).toFixed(2));
}
